import React, { Component } from "react";
import PropTypes from "prop-types";
import { defaultName } from "../utils/userUtils";
import { Typography } from "material-ui";
import TimeFromNow from "./TimeFromNow";
import { Link } from "react-router-dom";
import classNames from "classnames";
import { withStylesAndTranslation } from "../utils/container";

const styleSheet = theme => ({
    container: {
        textOverflow: "ellipses"
    },
    link: {
        flex: 1,
        textDecoration: "none"
    },
    flexContainer: {
        display: "flex",
        alignItems: "center"
    },
    unopened: {
        visibility: "visible"
    },
    opened: {
        visibility: "hidden"
    },
    indicator: {
        width: 8,
        height: 8,
        borderRadius: 4,
        marginRight: 1.5 * theme.spacing.unit,
        backgroundColor: theme.palette.primary[500]
    }
});

const TITLE_LENGTH = 20;

function shortTitle(body = "") {
    if (body.length < TITLE_LENGTH) {
        return body;
    }
    return body.substr(0, TITLE_LENGTH) + "…";
}

class Notification extends Component {
    static propTypes = {
        className: PropTypes.string,
        classes: PropTypes.object.isRequired,
        notification: PropTypes.object.isRequired,
        t: PropTypes.func.isRequired
    };

    getNotificationText() {
        let {
            t,
            notification: {
                post,
                correction,
                type,
                actingUser: { displayName }
            }
        } = this.props;
        displayName = defaultName(displayName);
        let title = "";

        if (post) {
            title = shortTitle(post.body);
        }

        const options = {
            displayName,
            title
        };

        switch (type) {
            case "new_correction":
                return t("notifications.newCorrection", options);
            case "new_comment":
                return t("notifications.newComment", options);
            case "post_reaction":
                return t("notifications.postReaction", options);
            case "correction_reaction":
                if (correction && correction.comment) {
                    return t("notifications.commentReaction", options);
                }
                return t("notifications.correctionReaction", options);
            default:
                return "";
        }
    }

    getLink() {
        let { notification: { type, postId, correctionId } } = this.props;

        switch (type) {
            case "new_correction":
            case "new_comment":
            case "correction_reaction":
                return `/posts/${postId}#correction=${correctionId}`;
            case "post_reaction":
            default:
                return `/posts/${postId}`;
        }
    }

    render() {
        const { classes } = this.props;
        let { notification: { creationDate, openedAtDate } } = this.props;

        const notificationText = this.getNotificationText();

        const indicatorClassname = classNames({
            [classes.unopened]: !openedAtDate,
            [classes.opened]: !!openedAtDate,
            [classes.indicator]: true
        });

        return (
            <div className={classes.flexContainer}>
                <div className={indicatorClassname} />

                <Link className={classes.link} to={this.getLink()}>
                    <Typography
                        className={classes.container}
                        type="body1"
                        component="div">
                        {notificationText}
                        <TimeFromNow date={creationDate} />
                    </Typography>
                </Link>
            </div>
        );
    }
}

export default withStylesAndTranslation(Notification, styleSheet);



// WEBPACK FOOTER //
// ./src/components/Notification.jsx